import styled from 'styled-components';
import { Card, Form, Button, InputGroup } from 'react-bootstrap';
import { COLORS } from 'modules/core/theme/colors';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';

export const LoginContent = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  overflow-y: auto;
  top: 0;
  left: 0;
  z-index: 3;

  @media (max-width: 575px) {
    padding: 10px;
  }
`;

export const BackgroundLayer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${STATIC_IMAGE_URLS.loginBackground});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: 0;
`;

export const DecorativeLayer = styled.div`
  position: fixed;
  top: 0;
  right: 0px;
  width: 100%;
  height: 100%;
  background-image: url(${STATIC_IMAGE_URLS.logoLoginBackground});
  background-size: 800px auto;
  background-repeat: no-repeat;
  background-position: right center;
  z-index: 1;
  pointer-events: none;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const LoginHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 42px;
  background-color: ${COLORS.BLUE_5};
  display: flex;
  align-items: center;
  padding-left: 28px;
  z-index: 10;
`;

export const HeaderLogo = styled.img`
  height: 26.469px;
  width: 140.364px;
`;

export const PositionCard = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 63px;
  position: relative;
  z-index: 2;
`;

export const CardForm = styled(Card)`
  min-height: 561px;
  width: 386px;
  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border-radius: 20px;
  box-shadow: 0px 0px 30px 0px rgba(14, 39, 86, 0.2), 0px 8px 24px 0px rgba(0, 0, 0, 0.08),
    0px 2px 4px 0px rgba(0, 0, 0, 0.02);
  font-family: Roboto, sans-serif;
  border: none;
  padding: 44px 34px 44px 34px;
  display: flex;
  flex-direction: column;
`;

export const CardImage = styled(Card.Img)`
  width: auto;
  height: 44px;
  margin: 0 auto 0;
  aspect-ratio: 2052 / 378;
`;

export const CardTitle = styled(Card.Title)`
  width: 100%;
  font-family: 'Poppins', sans-serif;
  font-weight: ${({ theme: { boldText } }) => boldText.dark};
  font-size: 20px;
  margin-bottom: 0px;
  color: ${COLORS.BLACK};
`;

export const Link = styled.a`
  border-radius: 20px;
  color: ${COLORS.BLUE_11};
  text-decoration: none;
  font-size: 16px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 1.4;

  &:hover {
    color: ${COLORS.BLUE_11};
    text-decoration: underline;
  }
`;

export const AgreementModalLink = styled.button`
  display: inline;
  border: none;
  background: none;
  padding: 0;
  color: ${COLORS.GREY_38};
  text-decoration: underline;
  font-size: 12px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 1.4;
  cursor: pointer;

  &:hover {
    color: ${COLORS.GREY_38};
    text-decoration: underline;
  }

  &:focus {
    outline: none;
  }
`;

export const LinkCreatePassword = styled.a`
  color: ${({ theme: { colors } }) => colors['blue-4']};
  font-size: 14px;
  text-decoration: none;

  &:hover {
    color: ${COLORS.BLUE_1};
    text-decoration: underline;
  }
`;

export const BackToLoginPosition = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 22px;
`;

export const FormControl = styled(Form.Control)`
  border-radius: 8px;
  border: 1px solid ${COLORS.GREY_34};
  background-color: ${COLORS.WHITE};
  box-shadow: none !important;
  padding: 10px 16px;
  font-size: 16px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 1;

  &:focus {
    border: 1px solid ${COLORS.GREY_34};
    z-index: 0 !important;
  }

  &::placeholder {
    color: ${COLORS.GREY_39};
    font-size: 16px;
  }
`;

export const EyeButton = styled(Button)`
  border-radius: 0;
  border: none;
  box-shadow: none !important;
  padding: 0;
`;

export const InputAppend = styled(InputGroup.Text)`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  padding: 0;
  background: none;
  border: none;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  max-width: 272px;
  height: 40px;
  padding: 0;
  margin: auto auto 0 auto;
  border-radius: 20px;
  border: 1px solid ${COLORS.BLUE_11} !important;
  font-size: 16px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-weight: 500;
  background-color: ${COLORS.BLUE_11} !important;
  box-shadow: none !important;

  &:disabled {
    opacity: 0.6;
  }

  &:hover:enabled {
    background-color: ${COLORS.BLUE_19} !important;
  }
`;

export const LoginFormPosition = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  & > div:first-child {
    padding-bottom: 18px;
  }
`;

export const ForgotPasswordFormPosition = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  & > div:first-child {
    padding-bottom: 10px;
  }

  & > div:nth-child(2) {
    padding-bottom: 34px;
  }
`;

export const CreatePasswordFormPosition = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  & > div:first-child {
    padding-bottom: 20px;
  }

  & > div:nth-child(2) {
    padding-bottom: 10px;
  }
`;

export const CreatePasswordSuccessPosition = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  & > div:first-child {
    padding-bottom: 10px;
  }

  & > div:nth-child(2) {
    padding-bottom: 30px;
  }
`;

export const SelectDealerFormPosition = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  & > div:first-child {
    padding-bottom: 10px;
  }

  & > div:nth-child(2) {
    padding-bottom: 30px;
  }
`;

export const PasswordInputFormGroup = styled.div`
  & > :nth-child(1) {
    padding-bottom: 14px;
  }
`;

export const LoginFormLabel = styled(Form.Label)`
  color: ${COLORS.GREY_36};
  font-size: 16px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 1.4;
`;

export const LoginFormCheck = styled(Form.Check)`
  color: ${COLORS.GREY_36};
  font-size: 16px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 5px;

  .form-check-input {
    margin-top: 0;
    margin-right: 0;
    border-color: ${COLORS.GREY_37};
    cursor: pointer;

    &:checked {
      background-color: ${COLORS.GREY_37};
      border-color: ${COLORS.GREY_37};
    }
  }

  .form-check-label {
    margin-bottom: 0;
    padding-top: 0;
  }
`;

export const PasswordInputDescription = styled.div`
  font-size: 14px;
  color: ${COLORS.GREY_38};
`;

export const LinkPosition = styled.div`
  width: 100%;
  padding: 22px 0 0 0;
  text-align: center;
`;

export const CheckboxAndLinkRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AndSpan = styled.span`
  font-size: 12px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 1.4;
  color: ${COLORS.GREY_38};
`;

export const ErrorMessage = styled.span`
  margin: 10px 0;
  font-size: 14px;
  color: ${COLORS.RED_3};
`;

export const LoginErrorSlot = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const FormSelect = styled(Form.Select)`
  border-radius: 8px;
  border: 1px solid ${COLORS.GREY_34};
  background-color: ${COLORS.WHITE};
  box-shadow: none !important;
  padding: 10px 16px;
  font-size: 16px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 1;

  &:focus {
    border: 1px solid ${COLORS.GREY_34};
    z-index: 0 !important;
  }
`;

export const TextSelectDealer = styled.div`
  width: 100%;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  background-color: transparent;
  border: none;
  color: ${COLORS.BLACK};
`;

export const TextForgotPassword = styled.div`
  width: 100%;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  background-color: transparent;
  border: none;
  font-size: 16px;
  color: ${COLORS.BLACK};
`;

export const CardBody = styled(Card.Body)`
  padding: 50px 0 0 0;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const FormGroupAcceptTermsConditions = styled(Form.Group)`
  display: flex;
  justify-content: center;
  margin-top: 5px;
  padding-bottom: 30px;
`;

export const AgreementCreatePassword = styled.div`
  text-align: justify;
  padding-left: 5px;
  margin-top: 1px;
  cursor: pointer;
`;

export const PasswordInputGroup = styled(InputGroup)`
  position: relative;
  width: 100%;

  .form-control {
    border-radius: 8px !important;
    padding-right: 44px;
  }

  .input-group-text {
    border: none;
    background: transparent;
  }
`;
